/**
 * @generated SignedSource<<e366a93401be71dda005b0701dfa95f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelEditMain_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EditorJsField_data" | "HotelEditMainGeneral_data" | "useEditorJsField_data">;
  readonly " $fragmentType": "HotelEditMain_data";
};
export type HotelEditMain_data$key = {
  readonly " $data"?: HotelEditMain_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditMain_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditMain_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HotelEditMainGeneral_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditorJsField_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useEditorJsField_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "335bd30c7ce6a08c6089c71623de4da0";

export default node;
